export default "__VITE_ASSET__e5c17fe0__"